import { ApiErrorResponse } from "shared/interfaces/api";

const CODE_ERRORS = [400, 401, 404, 500];

const extractMessages = (source: unknown): string[] => {
  if (!source) return [];

  if (typeof source === "string") {
    return [source];
  }

  if (Array.isArray(source)) {
    return source.filter((item): item is string => typeof item === "string");
  }

  if (typeof source === "object") {
    return Object.values(source)
      .flat()
      .filter((item): item is string => typeof item === "string");
  }

  return [];
};

export function getErrorsByApi(error: any, defaultMessage?: string) {
  if (!error) return;

  const tryThrow = (messages: string[]) => {
    if (messages.length > 0) {
      throw new Error(messages.join("\n"));
    }
  };

  if (error?.data) {
    const response = error.data as ApiErrorResponse & {
      status?: number;
      errors?: Record<string, string[] | string> | { Mensagens?: string[] | string } | null | undefined;
    };

    const status = response.statusCode ?? response.status;

    if (status && CODE_ERRORS.includes(status)) {
      tryThrow(extractMessages(response.messages));
      if (response.errors && typeof response.errors === "object" && response.errors !== null) {
        try {
          const errorsObj = response.errors as any;
          // Verificar se errorsObj existe, é um objeto e tem a propriedade Mensagens antes de acessar
          let errorsToExtract: any = response.errors;
          if (errorsObj && typeof errorsObj === "object" && errorsObj !== null && !Array.isArray(errorsObj)) {
            // Verificar se a propriedade Mensagens existe e não é undefined
            if (Object.prototype.hasOwnProperty.call(errorsObj, "Mensagens") && errorsObj.Mensagens !== undefined && errorsObj.Mensagens !== null) {
              errorsToExtract = errorsObj.Mensagens;
            }
          }
          tryThrow(extractMessages(errorsToExtract));
        } catch (err) {
          // Se houver erro ao processar errors, tenta extrair diretamente
          tryThrow(extractMessages(response.errors));
        }
      }
    }
  }

  if (error?.message) {
    throw new Error(error.message ?? defaultMessage ?? "Tivemos problemas ao realizar essa ação");
  }

  throw new Error(defaultMessage ?? "Tivemos problemas ao realizar essa ação");
}
